/**
 * Created By Elia Rohana on 3/20/19
 */
import EventBus from 'diagram-js/lib/core/EventBus';
import RuleProvider from 'diagram-js/lib/features/rules/RuleProvider';

export class ElementRuleMove extends RuleProvider {

    constructor(eventBus: EventBus) {
        super(eventBus);
    }

    init() {
        super.addRule('elements.move', 10001, (context) => {
            const target = context.target,
                shapes = context.shapes,
                position = context.position;

            return !target || (target && target.type === 'bpmn:Process');
        });
    }
}
